import { BASE_URL } from '../../config/environmentConfig';
import { sendSentryMessage } from '../utils/sentry-helper';
import * as Sentry from '@sentry/react';
import { GET } from '../store/store-helper';

export const fetchTokenizationKey = async (mid): Promise<any> => {
	try {
		let url = `${BASE_URL.TOKENIZATION_KEY}`;
		if (mid) {
			url += `?mid=${mid}`;
		}

		const data = await GET({ pathname: url });

		return data || '-';
	} catch (e) {
		Sentry.setTag('tokenization-mid', mid);
		sendSentryMessage({ name: `GET Fetch tokenization key error`, context: e });
		console.log('tokenization error', e);
	}
};
